<hx-dialog [title]="dialogTitle()">
  <div hxDialogContent>
    <div class="basic-control-rules-editor">
      <div class="basic-control-rules-editor__section">
        <p class="basic-control-rules-editor__hint">
          Define dynamic rules within {{ data.controlLabel }} to hide values, require values, or disable values based on
          selections in the same control.
        </p>

        @if (showValidationErrors() && validationErrors().length > 0) {
          <div class="basic-control-rules-editor__error-banner">
            <button
              hxIconButton
              type="button"
              svgIcon="ccs-x"
              variant="ghost"
              size="sm"
              context="neutral"
              (click)="dismissValidationErrors()"
              aria-label="Dismiss"></button>
            <div class="basic-control-rules-editor__error-content">
              <strong>Cannot Save:</strong>
              @for (error of validationErrors(); track $index) {
                <div>{{ error }}</div>
              }
            </div>
          </div>
        }

        @if (hasRules()) {
          <div class="basic-control-rules-editor__rules-list">
            @for (rule of rulesState(); track rule.id) {
              <div class="basic-control-rules-editor__rule-row">
                <div class="basic-control-rules-editor__rule-enabled">
                  <input
                    type="checkbox"
                    [checked]="rule.enabled"
                    (change)="toggleRuleEnabled(rule.id)"
                    title="Enable/disable this rule" />
                </div>

                <div class="basic-control-rules-editor__rule-content">
                  <div class="basic-control-rules-editor__rule-condition">
                    <span class="basic-control-rules-editor__rule-label">When</span>
                    <hx-dropdown
                      [options]="getOperatorOptions()"
                      [value]="rule.when.operator"
                      (valueChange)="updateRuleConditionOperator(rule.id, $any($event))"
                      class="basic-control-rules-editor__rule-dropdown"
                      size="sm"></hx-dropdown>

                    <hx-dropdown
                      [options]="optionChoices()"
                      [value]="rule.when.values"
                      [multiple]="data.inputType === 'multi-select'"
                      (valueChange)="updateRuleConditionValues(rule.id, $any($event))"
                      class="basic-control-rules-editor__rule-dropdown"
                      placeholder="Select values..."
                      size="sm"></hx-dropdown>
                  </div>

                  <div class="basic-control-rules-editor__rule-action">
                    <span class="basic-control-rules-editor__rule-label">Then</span>
                    <hx-dropdown
                      [options]="actionTypeOptions()"
                      [value]="rule.then.type"
                      (valueChange)="updateRuleActionType(rule.id, $any($event))"
                      class="basic-control-rules-editor__rule-dropdown"
                      size="sm"></hx-dropdown>

                    <hx-dropdown
                      [options]="optionChoices()"
                      [value]="rule.then.targetValues || []"
                      [multiple]="true"
                      (valueChange)="updateRuleActionValues(rule.id, $any($event))"
                      class="basic-control-rules-editor__rule-dropdown"
                      placeholder="Select values..."
                      size="sm"></hx-dropdown>
                  </div>
                </div>

                <div class="basic-control-rules-editor__rule-delete">
                  <button
                    hxIconButton
                    type="button"
                    svgIcon="ccs-x"
                    variant="ghost"
                    size="sm"
                    context="negative"
                    (click)="removeRule(rule.id)"
                    aria-label="Remove rule"></button>
                </div>
              </div>
            }
          </div>
        } @else {
          <div class="basic-control-rules-editor__empty">
            No rules defined. All values will remain available and nothing will be required.
          </div>
        }

        <button type="button" class="basic-control-rules-editor__add-btn" (click)="addRule()">+ Add Rule</button>
      </div>
    </div>
  </div>

  <div hxDialogActions class="basic-control-rules-editor__footer">
    <span></span>
    <div class="basic-control-rules-editor__footer-actions">
      <button hxButton type="button" variant="outline" context="neutral" (click)="cancel()">Cancel</button>
      <button hxButton type="button" variant="fill" context="positive" (click)="save()">Save</button>
    </div>
  </div>
</hx-dialog>
